export default "__VITE_ASSET__CgQxoKXW__"